var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowHeadDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.2832,
    y: 0.833984,
    width: 1.68222,
    height: 12.9189,
    rx: 0.841109,
    transform: "rotate(45 17.2832 0.833984)",
    fill: "#3B1F8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 2.33008,
    width: 1.68222,
    height: 12.4983,
    rx: 0.841109,
    transform: "rotate(-45 0.500061 2.33008)",
    fill: "#3B1F8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHeadDownBlue);
export default __webpack_public_path__ + "static/media/arrowHeadDownBlue.d8a57a9b542403de49e1c38a9cc8858b.svg";
export { ForwardRef as ReactComponent };